/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ClothesOuterTshirtIcon16Solid = forwardRef('ClothesOuterTshirtIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.5 1a.5.5 0 0 1 .5.5 2 2 0 1 0 4 0 .5.5 0 0 1 .5-.5h1.08a3 3 0 0 1 2.724 1.743l1.59 3.442a1.25 1.25 0 0 1-.783 1.724L13 8.529V12.5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 3 12.5V8.53L.889 7.908a1.25 1.25 0 0 1-.782-1.724l1.589-3.442A3 3 0 0 1 4.419 1H5.5Z" })));
});
